<template>
  <With_Header_Modal_Template title="Отзыв" width="600px">
    <div class="pwrap">
      <form @submit.prevent="">
        <div style="margin-bottom: 20px">
          <textarea v-model="form.text" id="" cols="30" rows="6" placeholder="Ваш отзыв..." style="margin-bottom: 0" @change="()=>errors.text = null"></textarea>
          <error-text :text="errors.text"/>
        </div>
        <div class="bot">

          <div style="    margin-bottom: 20px;">
            <div class="rate">
              <div class="rating-area">
                <input type="radio" id="star-5" name="rating" value="5" v-model="form.rate">
                <label for="star-5" title="Оценка «5»"></label>
                <input type="radio" id="star-4" name="rating" value="4" v-model="form.rate">
                <label for="star-4" title="Оценка «4»"></label>
                <input type="radio" id="star-3" name="rating" value="3" v-model="form.rate">
                <label for="star-3" title="Оценка «3»"></label>
                <input type="radio" id="star-2" name="rating" value="2" v-model="form.rate">
                <label for="star-2" title="Оценка «2»"></label>
                <input type="radio" id="star-1" name="rating" value="1" v-model="form.rate">
                <label for="star-1" title="Оценка «1»"></label>
              </div>
            </div>
            <error-text :text="errors.rate"/>
          </div>


        </div>
      </form>

      <button-component
        v-if="isMobile"
        mb="10px"
        variant="filled"
        type="submit"
        @click="$eventHub.$emit('review.create', form)"
      >Оставить отзыв
      </button-component>
    </div>
    <div slot="footer">
      <button-component
          mb="10px"
          variant="filled"
          type="submit"
          @click="$eventHub.$emit('review.create', form)"
      >Оставить отзыв
      </button-component>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import ErrorText from "@/components/ui/text/error-text";
import ButtonComponent from '../../components/ui/buttons/button-component'
import {mapMutations} from 'vuex'
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'

export default {
  name: 'Review',
  components: {With_Header_Modal_Template, ButtonComponent, ErrorText},
  mounted() {
    this.$eventHub.$on('review.create.error', (errors) => this.errors = errors);
  },
  data() {
    return {
      errors: {},
      form: {rate: 0, text: null},
    }
  },
  computed: {
    isMobile() {
      return document.documentElement.clientWidth < 991
    }
  },
  methods: mapMutations(['openModal']),
  beforeDestroy() {
    this.$eventHub.$off('review.create.error');
  },
}
</script>

<style scoped lang="scss">
.pwrap {
  padding: 0 20px;
}

.bot {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
}

.rate {
  display: flex;
  align-items: center;

  .rating-area {
    overflow: hidden;
    margin-bottom: 8px;
  }

  .rating-area:not(:checked) > input {
    display: none;
  }

  .rating-area:not(:checked) > label {
    float: right;
    width: 20px;
    padding: 0;
    cursor: pointer;
    font-size: 20px;
    line-height: 20px;
    content: url(../../assets/images/icons/star-gray.svg);
  }

  .rating-area:not(:checked) > label:before {
    content: url(../../assets/images/icons/star.svg);
  }

  .rating-area > input:checked ~ label {
    content: url(../../assets/images/icons/star.svg);
  }

  .rating-area:not(:checked) > label:hover,
  .rating-area:not(:checked) > label:hover ~ label {
    content: url(../../assets/images/icons/star.svg);
  }

  .rating-area > input:checked + label:hover,
  .rating-area > input:checked + label:hover ~ label,
  .rating-area > input:checked ~ label:hover,
  .rating-area > input:checked ~ label:hover ~ label,
  .rating-area > label:hover ~ input:checked ~ label {
    content: url(../../assets/images/icons/star.svg);
  }

  .rate-area > label:active {
    position: relative;
  }
}


textarea {
  padding: 0 10px;
  resize: none;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 20px;
  border: 1px solid #DBBFA7;
  border-radius: 5px;
  background: initial;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #6d6d6d;

  &:focus {
    border: 1px solid #d9a980;
    outline: none;

  }

  .mb-20 {
    margin-bottom: 20px;
  }
}
</style>
